import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { GetGroupsListForVendorPayload } from "../../payload/GetGroupsListForVendor/GetGroupsListForVendorPayload";

const getGroupsListForVendorFetch = (state: GroupsState, action: PayloadAction<GetGroupsListForVendorPayload>) => {
    state.isLoading = true
}

export default getGroupsListForVendorFetch;